<template>
    <div>
        <NavBar ></NavBar>
        <div class="row">
            <MarketWatch ></MarketWatch>
        </div>
    </div>
</template>

<script>
import NavBar from '@/components/main/NavBar.vue'
import MarketWatch from '@/components/marketwatch/MarketWatch'
export default {
  name: 'MarketWatchNav',
  components: {
    MarketWatch,
    NavBar
  }
}
</script>



// WEBPACK FOOTER //
// src/components/marketwatch/MarketWatchNav.vue